import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AltaCbuService {  

  constructor(private http: HttpClient) { }

  sendCBU(cuit,formData): Observable<any> {
      return this.http.post(`${environment.urlApi}proveedor/sendFormCBU?cuit=${cuit}`, formData);
  }
}
